import { render } from "./CardUserAvatar.vue?vue&type=template&id=f02f7426&scoped=true"
import script from "./CardUserAvatar.vue?vue&type=script&lang=js"
export * from "./CardUserAvatar.vue?vue&type=script&lang=js"

import "./CardUserAvatar.vue?vue&type=style&index=0&id=f02f7426&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f02f7426"]])

export default __exports__